import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { makeStyles, useTheme, createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import CallIcon from "@material-ui/icons/CreditCard";
import ImportExport from "@material-ui/icons/ImportExport";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Select from "@material-ui/core/Select";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItem from "@material-ui/core/ListItem";
import Collapse from "@material-ui/core/Collapse";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import AlarmOn from "@material-ui/icons/AlarmOn";
import FeaturedPlayList from "@material-ui/icons/FeaturedPlayList";
import AccountCircle from "@material-ui/icons/AccountCircle";
import AccessAlarm from "@material-ui/icons/AccessAlarm";
import DirectionsBus from "@material-ui/icons/DirectionsBus";
import Assignment from "@material-ui/icons/Assignment";
import GroupSharp from "@material-ui/icons/GroupSharp";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import SupervisedUserCircle from "@material-ui/icons/SupervisedUserCircle";
import GradientSharp from "@material-ui/icons/GradientSharp";
import Dashboard from "./Dashboard";
import Equipment from "./Equipment";
import Report from "./Report";
import Admin from "./Admin";
import Alarm from "./Alarm";
import Profile from "./UserProfile";
import RFIDTagPage from "./RFIDTagPage";
import ImportTag from "./ImportTag";
import AdminEditUser from "./AdminEditUser";
import AdminAddUser from "./AdminAddUser";
import Cookies from "js-cookie";
import {
  BrowserRouter as Router,
  Redirect,
  Switch,
  Route,
  useRouteMatch,
  useHistory,
  useLocation,
} from "react-router-dom";
import { useContext } from "react";
const jwt = require("jsonwebtoken");
const { default: utils } = require("../../utils/functions.js");
const _ = require("lodash");
const axios = require("axios");
const { addNumbers } = utils;

const DashboardPage = () => {
  let [currentOrganisation, setCurrentOrganisation] = useState("");
  let [previousCurrentOrganisation, setPrevCurrentOrganisation] = useState("");
  let [switchingOrg, setSwitchingOrg] = useState("");
  const [openTabs, setOpenTabs] = useState(true);
  const [reportData, getReportData] = useState(false);
  const [reportDataFields, setreportDataFields] = useState(false);
  const [allOrganisationLists, setAllOrganisationLists] = useState(false);
  const [allowedOrgList, setAllowedOrgList] = useState(false);
  const [userLists, setUserLists] = useState(false);
  const [alarms, getAlarms] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedColor, setSelectedColor] = useState(false);
  const [currentUserOrg, setCurrentUserOrg] = useState("");
  const [editUserOrg, setEditUserOrg] = useState("");
  const [refreshData, setRefreshData] = useState(false);
  const [specialPageName, setSpecialPageName] = useState(false);
  const [tokenStillValid, setTokenStillValid] = useState(true);
  const [drawerWidth, setDrawerWidth] = useState(260);
  let location = useLocation();
  let history = useHistory();

  useEffect(async () => {
    if (!tokenStillValid) {
      let authObj = Cookies.get("authObj");
      let token;
      let success;
      if (authObj) {
        authObj = JSON.parse(authObj);
        token = authObj["token"];
      }

      let refreshTokenBody = {
        accesstoken: token,
      };

      if (currentOrganisation && currentOrganisation === "ntuGomic") {
      }
      let refreshToken = await axios.post(
        `${process.env.REACT_APP_API}/refreshToken`,
        refreshTokenBody,
        { "Content-Type": "application/json" }
      );
      refreshToken = refreshToken.data;
      ({ success, refreshToken } = refreshToken);

      if (!success) {
        setAnchorEl(null);
        history.push("/login");
        Cookies.remove("authObj");
        Cookies.remove("page");
      } else {
        authObj["token"] = refreshToken;
        authObj["lastRefreshDate"] = new Date().toString();
        Cookies.set("authObj", authObj);
        setTokenStillValid(true);
      }
    }
  }, [tokenStillValid]);

  useEffect(async () => {
    let authObj = Cookies.get("authObj");
    let token;
    if (authObj) {
      authObj = JSON.parse(authObj);
      token = authObj["token"];
    }
    let apiKeys = {
      admin: "jnjirej9reinvuiriuerhuinui",
      serviceUser: "juit959fjji44jcion4moij0kc",
    };

    if (!token) {
      history.push("/login");
    }

    console.log(currentOrganisation);

    if (currentOrganisation === "ntuGomic") {
      history.push("/dashboard/equipment");
    }

    let config = {
      headers: { Authorization: `Bearer ${token}`, apikey: apiKeys["admin"] },
    };

    let checkExpiry = await axios.post(
      `${process.env.REACT_APP_API}/checkTokenExpiry`,
      {},
      config
    );

    checkExpiry = checkExpiry.data;
    let { success } = checkExpiry;
    if (!success) {
      setTokenStillValid(false);
    }

    if (!reportData) {
      let config = {
        headers: { Authorization: `Bearer ${token}`, apikey: apiKeys["admin"] },
      };
      // currentOrganisation = currentOrganisation || 'ntu';
      axios
        .get(
          `${process.env.REACT_APP_API}/getReportAndEquipmentData/${currentOrganisation}/false/false`,
          config
        )
        .then((response) => {
          getReportData(response.data.result);
          setSwitchingOrg(currentOrganisation);
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    if (!reportDataFields) {
      let config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      axios
        .get(`${process.env.REACT_APP_API}/getReportFields`, config)
        .then((response) => {
          setreportDataFields(response.data.result);
        })
        .catch(function (error) {});
    }

    if (!allowedOrgList) {
      let config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      axios
        .get(`${process.env.REACT_APP_API}/getOrganisationLists`, config)
        .then((response) => {
          let { success } = response.data;
          if (!success) {
            setTokenStillValid(false);
          }
          let allowedOrgList = response.data.organisations;
          let startingCurrentOrg = allowedOrgList[0].organisation;
          setCurrentOrganisation(startingCurrentOrg);
          setAllowedOrgList(allowedOrgList);
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    if (!allOrganisationLists) {
      let config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      axios
        .get(`${process.env.REACT_APP_API}/getAllOrganisationsLists`, config)
        .then((response) => {
          let { success } = response.data;
          if (!success) {
            setTokenStillValid(false);
          }
          setAllOrganisationLists(response.data.organisations);
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    if (!alarms) {
      let config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      axios
        .get(`${process.env.REACT_APP_API}/alarmCurrentStatus`, config)
        .then((response) => {
          let { success } = response.data;
          if (!success) {
            setTokenStillValid(false);
          }
          getAlarms(response.data.alarms);
        })
        .catch(function (error) {});
    }

    if (!userLists) {
      let config = {
        headers: { Authorization: `Bearer ${token}`, apikey: apiKeys["admin"] },
      };
      axios
        .get(`${process.env.REACT_APP_API}/listOfUsers`, config)
        .then((response) => {
          let { success } = response.data;
          if (!success) {
            setTokenStillValid(false);
          }
          setUserLists(response.data.userLists);
          let userLists = response.data.userLists;
          if (token) {
            jwt.verify(
              token,
              "6jFLnuPANxk4UzePcRSTRkwXSqxhAMf2FAm4VFvV",
              (err, decoded) => {
                let selfUserID = decoded.userid;
                let currentUser = userLists.find(
                  (user) => user.id === selfUserID
                );
                let currentUserOrg = currentUser["organisation"];
                setCurrentUserOrg(currentUserOrg);
              }
            );
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, []);

  useEffect(() => {
    getReportData(false);
    let token;
    let authObj = Cookies.get("authObj");
    if (authObj) {
      authObj = JSON.parse(authObj);
      token = authObj["token"];
    }
    let apiKeys = {
      admin: "jnjirej9reinvuiriuerhuinui",
      serviceUser: "juit959fjji44jcion4moij0kc",
    };
    let config = {
      headers: { Authorization: `Bearer ${token}`, apikey: apiKeys["admin"] },
    };
    axios
      .get(
        `${process.env.REACT_APP_API}/getReportAndEquipmentData/${currentOrganisation}/false/false`,
        config
      )
      .then((response) => {
        getReportData(response.data.result);
        setSwitchingOrg(currentOrganisation);

        if (currentOrganisation === "800_SGbins") {
          setDrawerWidth(300);
        }
      })
      .catch(function (error) {
        console.log(error);
      });

    // if(previousCurrentOrganisation)
    console.log(previousCurrentOrganisation);
    console.log(currentOrganisation);
    console.log(history);
    let path = history.location;
    path = path.pathname;
    // if (path !== "/dashboard/admin") {
    //   if (previousCurrentOrganisation) {
    //     setCurrentOrganisation(previousCurrentOrganisation);
    //     setPrevCurrentOrganisation("");
    //   }
    // }
  }, [currentOrganisation]);

  // --------- useStyles code here --------
  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
    },
    selectRoot: {
      color: "white",
      borderBlockColor: "white",
      display: "flex",
      marginRight: -10,
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    rightToolbar: {
      marginLeft: "auto",
      marginRight: -12,
    },
    hide: {
      display: "none",
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: "nowrap",
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: "hidden",
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9) + 1,
      },
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
  }));

  // const theme = createTheme({
  //   palette: {
  //     primary: { main: "#ffffff" },
  //   },
  // });

  let userType;
  let organisation;
  setInterval(async () => {
    let token;
    let authObj = Cookies.get("authObj");
    if (authObj) {
      authObj = JSON.parse(authObj);
      token = authObj["token"];
    }
    let apiKeys = {
      admin: "jnjirej9reinvuiriuerhuinui",
      serviceUser: "juit959fjji44jcion4moij0kc",
    };

    let config = {
      headers: { Authorization: `Bearer ${token}`, apikey: apiKeys["admin"] },
    };
    let checkExpiry = await axios.post(
      `${process.env.REACT_APP_API}/checkTokenExpiry`,
      {},
      config
    );
    checkExpiry = checkExpiry.data;
    console.log(checkExpiry);
    let { success } = checkExpiry;
    if (!success) {
      setTokenStillValid(false);
    }
  }, 900000);

  let authObj = Cookies.get("authObj");
  if (authObj) {
    authObj = JSON.parse(authObj);
    let { token } = authObj;
    jwt.verify(
      token,
      "6jFLnuPANxk4UzePcRSTRkwXSqxhAMf2FAm4VFvV",
      (err, decoded) => {
        ({ organisation, accessLvl: userType } = decoded);
      }
    );
  }

  let { pathname: locationPath } = location;

  let dType = "Alarm";

  const [dataType, setDataType] = useState(dType);

  let page;
  switch (locationPath) {
    case "/dashboard":
      page = "Dashboard";
      break;
    case "/dashboard/equipment":
      page = "Equipment";
      break;
    case "/dashboard/profile":
      page = "Profile";
      break;
    case "/dashboard/editProfile":
      page = "Edit Profile";
      break;
    case "/dashboard/alarms":
      page = "Alarms";
      break;
    case "/dashboard/report":
      page = `${dataType} Report`;
      if (dataType === "Other") {
        page = specialPageName || page;
      }
      break;
    case "/dashboard/admin":
      page = "Admin";
      break;
    case "/dashboard/adminAddUser":
      page = "Add User";
      break;
    case "/dashboard/tagdata":
      page = "Tag Data";
      break;
    case "/dashboard/importtags":
      page = "Import Tag";
      break;
    default:
  }

  if (locationPath.includes("/dashboard/adminEditUser")) {
    page = "Edit User";
  }

  let ignoredPages = [
    "Admin",
    "Edit User",
    "Add User",
    "Profile",
    "Edit Profile",
  ];

  let isIgnored = ignoredPages.includes(page);
  let noOfAlarms = 0;
  let currentOrg;
  if (isIgnored && allowedOrgList) {
    let startingCurrentOrg = previousCurrentOrganisation || currentOrganisation;
    // let startingCurrentOrg = 'sembwaste';
    currentOrg = startingCurrentOrg;
  } else {
    currentOrg =
      currentOrg || previousCurrentOrganisation || currentOrganisation;
  }

  let unClearedAlarms = [];

  if (alarms && !isIgnored && allowedOrgList) {
    if (allowedOrgList.length > 1) {
      [unClearedAlarms] = alarms.filter((alarm) => alarm[currentOrg]);
      unClearedAlarms = unClearedAlarms[currentOrg];
    } else {
      unClearedAlarms = alarms;
    }
    unClearedAlarms = unClearedAlarms.filter(
      (alarms) => alarms.CurrentStatus === "Triggered"
    );
    unClearedAlarms = _.uniqBy(unClearedAlarms, (alarm) =>
      [alarm.EquipmentID, alarm.Type].join()
    );
    noOfAlarms = unClearedAlarms.length;
  }

  let equipmentWeight;
  let mapData;
  let levelInformation;
  // console.log(reportData);
  // console.log(switchingOrg);
  // console.log(currentOrg);
  // console.log(currentOrganisation);

  if (reportData && switchingOrg === currentOrg && !isIgnored) {
    let [equipmentData] = reportData[currentOrg];
    equipmentData = equipmentData["Equipment"]["equipmentInformation"];
    equipmentData = equipmentData.map((equip) => {
      return equip.WeightValue;
    });
    equipmentData = equipmentData.filter(Boolean);

    if (equipmentData.length > 0) {
      for (let i = 0; i < equipmentData.length; i++) {
        let equipment = equipmentData[i];
        if (equipment < 0) {
          equipmentData[i] = 0;
        } else {
          equipmentData[i] = parseInt(equipment);
        }
      }
    }
    equipmentWeight = addNumbers(equipmentData);

    [mapData] = reportData[currentOrg];
    levelInformation = mapData["Equipment"]["levelInformation"];

    mapData = mapData["Equipment"]["mapData"];
    mapData = mapData.map((equip) => {
      let alarm;
      if (noOfAlarms > 0) {
        alarm = unClearedAlarms.find(
          (al) => al.EquipmentID === equip.EquipmentID
        );
      }

      if (alarm) {
        equip["Level"] = "red";
      }
      return equip;
    });
    if (selectedColor) {
      mapData = mapData.filter((data) => {
        if (data["Level"] === selectedColor) {
          return data;
        }
      });
    }
    // setWeightValue(equipmentWeight);
  }
  const { path } = useRouteMatch();
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);

  const handleOpenTabs = () => {
    setOpenTabs(!openTabs);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosed = () => {
    setAnchorEl(null);
  };

  const handleClose = (type) => {
    if (type === "logout") {
      setAnchorEl(null);
      history.push("/login");
      Cookies.remove("authObj");
      Cookies.remove("page");
    }

    if (type === "profile") {
      setAnchorEl(null);
      history.push("/dashboard/profile");
    }
  };

  let menuItems = <></>;

  let orgList = allOrganisationLists;
  if (allOrganisationLists && allowedOrgList) {
    if (ignoredPages.includes(page)) {
      if (organisation !== "izeem") {
        let ownOrg = allOrganisationLists.find(
          (org) => org.organisation === organisation
        );
        orgList = [ownOrg, ...allowedOrgList];
        if (allowedOrgList.length === 1) {
          orgList = allowedOrgList;
        }
      }
    } else {
      orgList = allowedOrgList;
    }
    // orgList = orgList.filter(Boolean);
    menuItems = orgList.map((org) => {
      let { organisation, showOrgAs } = org;
      return (
        <MenuItem
          onClick={() => {
            let isAllowed = allowedOrgList.find(
              (org) => org.organisation === organisation
            );

            if (isAllowed) {
              setCurrentOrganisation(organisation);
              setPrevCurrentOrganisation(organisation);
            } else {
              setCurrentOrganisation(organisation);
            }
            setDataType("Alarm");
            // Cookies.set('dataType', `Alarm`);
          }}
          value={organisation}
        >
          <Typography variant="h6" noWrap>
            {showOrgAs}
          </Typography>
        </MenuItem>
      );
    });
  }

  let listItemsArray = ["Dashboard", "Equipment", "Report", "Admin"];

  if (noOfAlarms > 0) {
    listItemsArray = ["Dashboard", "Equipment", "Alarms", "Report", "Admin"];
  }

  if (userType !== "admin") {
    let tempListArray = [];
    for (let i = 0; i < listItemsArray.length; i++) {
      if (listItemsArray[i] !== "Admin") {
        tempListArray.push(listItemsArray[i]);
      }
    }
    listItemsArray = tempListArray;
    tempListArray = undefined;
  }

  if (
    currentOrganisation === "ntuGomic" ||
    previousCurrentOrganisation === "ntuGomic"
  ) {
    if (organisation === "izeem") {
      listItemsArray.splice(listItemsArray.length - 2, 0, "RFID Tag Menu");
    } else {
      if (userType === "admin" || userType === "serviceUser") {
        listItemsArray.splice(listItemsArray.length - 1, 0, "RFID Tag Menu");
      }
    }
    listItemsArray.splice(0, 1);
    // history.push('history.push("/login");')
  }

  let organisationReportFields;
  if (reportDataFields && currentOrg) {
    [organisationReportFields] = reportDataFields.filter((field) => {
      if (field.organisation === currentOrg) {
        return field;
      }
    });

    organisationReportFields = organisationReportFields["reportInformation"];
  }

  let collapseFields = [
    { type: "Alarm", fieldName: "Alarm" },
    { type: "Weight", fieldName: "Weight" },
  ];
  let RFIDTagCollapseField = [
    { type: "tagData", fieldName: "Tag User Details" },
  ];
  if (organisation === "izeem") {
    RFIDTagCollapseField = [
      { type: "importTags", fieldName: "Import Tag Users" },
      { type: "tagData", fieldName: "Tag User Details" },
    ];
  }

  if (organisationReportFields) {
    if (organisationReportFields["Other"]) {
      collapseFields = [
        { type: "Alarm", fieldName: "Alarm" },
        {
          type: "Other",
          fieldName:
            organisationReportFields["Other"]["ReportFields"]["knownAS"],
        },
      ];
      // page = organisationReportFields['Other']['ReportFields']['knownAS'];
    }
  }

  let collapse = <></>;
  let RFIDCollapse = <></>;

  let icons = {
    Dashboard: <GradientSharp />,
    Alarms: <AccessAlarm />,
    Equipment: <DirectionsBus />,
    Report: <Assignment />,
    "RFID Tag Menu": <CallIcon />,
    "Import Tag": <ImportExport />,
    "Tag Details": <SupervisedUserCircle />,
    Admin: <GroupSharp />,
    CollapseAlarm: <AlarmOn />,
    CollapseOther: <FeaturedPlayList />,
    CollapseWeight: <FeaturedPlayList />,
  };
  collapse = collapseFields.map((field) => {
    let icon = <></>;
    switch (field.type) {
      case "Alarm":
        icon = icons["CollapseAlarm"];
        break;
      case "Weight":
        icon = icons["CollapseWeight"];
        break;
      case "Other":
        icon = icons["CollapseOther"];
        // page = 'Hii';
        break;
      default:
      // code block
    }

    RFIDCollapse = RFIDTagCollapseField.map((field) => {
      let fieldType = field["type"].toLowerCase();

      let renderBlue = {
        tagdata: "Tag Data",
        importtags: "Import Tag",
      };
      let icon = <></>;
      switch (field.type) {
        case "tagData":
          icon = icons["Tag Details"];
          break;
        case "importTags":
          icon = icons["Import Tag"];
          break;
        default:
        // code block
      }
      return (
        <ListItem
          onClick={async () => {
            let authObj = Cookies.get("authObj");
            let token;
            if (authObj) {
              authObj = JSON.parse(authObj);
              token = authObj["token"];
            }
            let apiKeys = {
              admin: "jnjirej9reinvuiriuerhuinui",
              serviceUser: "juit959fjji44jcion4moij0kc",
            };
            let config = {
              headers: {
                Authorization: `Bearer ${token}`,
                apikey: apiKeys["admin"],
              },
            };
            let checkExpiry = await axios.post(
              `${process.env.REACT_APP_API}/checkTokenExpiry`,
              {},
              config
            );
            checkExpiry = checkExpiry.data;
            let { success } = checkExpiry;

            if (!success) {
              setTokenStillValid(false);
            } else {
              history.push(`${path}/${fieldType}`);
            }
          }}
          style={
            page === renderBlue[fieldType]
              ? { backgroundColor: "#26477c", color: "white" }
              : null
          }
          // style={{ backgroundColor: "#26477c", color: "white" }}
          button
          className={classes.nested}
        >
          <ListItemIcon
            style={
              `${field["type"]} Report` === page ||
              `${field.fieldName} Report` === page
                ? { color: "white" }
                : null
            }
          >
            {icon}
          </ListItemIcon>
          <span style={{ fontFamily: "Roboto", fontSize: "1em" }}>
            {field["fieldName"]}
          </span>
        </ListItem>
      );
    });

    return (
      <ListItem
        onClick={async () => {
          let authObj = Cookies.get("authObj");
          let token;
          if (authObj) {
            authObj = JSON.parse(authObj);
            token = authObj["token"];
          }
          let apiKeys = {
            admin: "jnjirej9reinvuiriuerhuinui",
            serviceUser: "juit959fjji44jcion4moij0kc",
          };
          let config = {
            headers: {
              Authorization: `Bearer ${token}`,
              apikey: apiKeys["admin"],
            },
          };
          let checkExpiry = await axios.post(
            `${process.env.REACT_APP_API}/checkTokenExpiry`,
            {},
            config
          );
          checkExpiry = checkExpiry.data;
          let { success } = checkExpiry;

          if (!success) {
            setTokenStillValid(false);
          } else {
            console.log("report buttons");
            setDataType(field["type"]);
            if (field["type"] === "Other") {
              let { fieldName } = field;
              if (fieldName.includes("Report")) {
                setSpecialPageName(fieldName);
              } else {
                setSpecialPageName(`${fieldName} Report`);
              }
            } else {
              setSpecialPageName(false);
            }
            // Cookies.set('dataType', field['type']);
            if (isIgnored) {
              let startingCurrentOrg =
                previousCurrentOrganisation || currentOrganisation;
              if (previousCurrentOrganisation) {
                setCurrentOrganisation(startingCurrentOrg);
              }
            }
            history.push(`${path}/report`);
          }
        }}
        style={
          `${field["type"]} Report` === page ||
          `${field.fieldName} Report` === page ||
          field.fieldName === page
            ? { backgroundColor: "#26477c", color: "white" }
            : null
        }
        button
        className={classes.nested}
      >
        <ListItemIcon
          style={
            `${field["type"]} Report` === page ||
            `${field.fieldName} Report` === page
              ? { color: "white" }
              : null
          }
        >
          {icon}
        </ListItemIcon>
        <span style={{ fontFamily: "Roboto", fontSize: "1em" }}>
          {field["fieldName"]}
        </span>
      </ListItem>
    );
  });

  let listItems = listItemsArray.map((items) => {
    let itemSmallText = items.toLowerCase();

    let pathRoute = `${path}/${itemSmallText}`;
    if (items === "Dashboard") {
      pathRoute = `${path}`;
    }
    console.log(items);

    let icon = icons[items];
    if (items === "RFID Tag Menu") {
      return (
        <>
          <ListItem button onClick={handleOpenTabs}>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={items} />
            {openTabs ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openTabs} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {RFIDCollapse}
            </List>
          </Collapse>
        </>
      );
    }
    if (items === "Report") {
      return (
        <>
          <ListItem button onClick={handleOpenTabs}>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={items} />
            {openTabs ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openTabs} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {collapse}
            </List>
          </Collapse>
        </>
      );
    } else {
      return (
        <ListItem
          onClick={async () => {
            let authObj = Cookies.get("authObj");
            let token;
            if (authObj) {
              authObj = JSON.parse(authObj);
              token = authObj["token"];
            }

            let apiKeys = {
              admin: "jnjirej9reinvuiriuerhuinui",
              serviceUser: "juit959fjji44jcion4moij0kc",
            };
            let config = {
              headers: {
                Authorization: `Bearer ${token}`,
                apikey: apiKeys["admin"],
              },
            };
            let checkExpiry = await axios.post(
              `${process.env.REACT_APP_API}/checkTokenExpiry`,
              {},
              config
            );
            checkExpiry = checkExpiry.data;
            let { success } = checkExpiry;
            if (!success) {
              setTokenStillValid(false);
            } else {
              console.log("buttons");

              if (isIgnored) {
                let startingCurrentOrg =
                  previousCurrentOrganisation || currentOrganisation;
                setCurrentOrganisation(startingCurrentOrg);
                if (!orgList.includes(currentOrganisation)) {
                  setCurrentOrganisation(startingCurrentOrg);
                }
              }

              // console.log(itemSmallText);

              // if (itemSmallText === "admin") {
              //   setPrevCurrentOrganisation(currentOrganisation);
              // }

              history.push(pathRoute);
            }
          }}
          style={
            items === page
              ? { backgroundColor: "#26477c", color: "white" }
              : null
          }
          button
        >
          <ListItemIcon style={items === page ? { color: "white" } : null}>
            {icon}
          </ListItemIcon>
          <ListItemText primary={items} />
        </ListItem>
      );
    }
  });

  let profilePages = ["Edit Profile", "Profile", "Edit User"];
  let dropDownDisabled = false;
  if (profilePages.includes(page) || orgList.length < 2) {
    dropDownDisabled = true;
  }

  let parsedOrg = currentOrganisation;

  if (page === "Edit Profile" || page === "Profile") {
    parsedOrg = currentUserOrg || currentOrganisation;
  }

  if (page === "Edit User") {
    parsedOrg = editUserOrg || currentOrganisation;
  }

  let orgDropDown = (
    <Select
      style={{ color: "white" }}
      className={classes.selectRoot}
      disabled={dropDownDisabled}
      labelId="label"
      id="select"
      value={parsedOrg}
    >
      {menuItems}
    </Select>
  );

  if (allOrganisationLists.length <= 1) {
    orgDropDown = <></>;
  }

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          style={{ backgroundColor: "#26477c", color: "white" }}
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: open,
          })}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.menuButton, {
                [classes.hide]: open,
              })}
            >
              <ArrowForwardIosIcon />
            </IconButton>
            <Typography variant="h6" noWrap>
              {/* IZeeSync */}
              {page}
            </Typography>
            <Typography
              style={{
                flexGrow: 1,
                textAlign: "center",
                // marginRight: '5em',
              }}
              variant="h6"
              noWrap
            >
              <img
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (currentOrganisation === "ntuGomic") {
                    history.push("/dashboard/equipment");
                  } else {
                    history.push("/dashboard");
                  }
                }}
                width="140"
                height="30"
                src="https://imagesmapicon.s3.ap-southeast-1.amazonaws.com/izeesync_white_words.png"
              />
            </Typography>
            {orgDropDown}
            &nbsp; &nbsp; &nbsp;
            <IconButton
              className={classes.rightToolbar}
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              edge="end"
              // onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle onClick={handleClick} />

              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClosed}
              >
                {/* <MenuItem onClick={handleClose}>My account</MenuItem> */}
                <MenuItem
                  onClick={() => {
                    Cookies.set("page", `Profile`);
                    handleClose("profile");
                  }}
                >
                  Profile
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleClose("logout");
                  }}
                >
                  Logout
                </MenuItem>
              </Menu>
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            }),
          }}
        >
          <div className={classes.toolbar}>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </div>
          <Divider />
          <List>{listItems}</List>
          <Divider />
        </Drawer>
        <main className={classes.content}>
          <div className={classes.toolbar} />
          <div>
            <Switch>
              <Route
                exact
                path={`${path}/importtags`}
                component={() => (
                  <ImportTag
                    currentOrganisation={currentOrg}
                    setCurrentOrganisation={setCurrentOrganisation}
                  />
                )}
              />
              <Route
                exact
                path={`${path}/tagdata`}
                component={() => (
                  <RFIDTagPage currentOrganisation={currentOrganisation} />
                )}
              />
              <Route
                exact
                path={`${path}/profile`}
                component={() => (
                  <Profile
                    setRefreshData={setRefreshData}
                    setEditUserOrg={setEditUserOrg}
                  />
                )}
              />
              <Route
                exact
                path={`${path}/editProfile`}
                component={() => (
                  <AdminEditUser
                    orgList={orgList}
                    setRefreshData={setRefreshData}
                    setEditUserOrg={setEditUserOrg}
                  />
                )}
              />
              <Route
                exact
                path={`${path}`}
                component={() => (
                  <Dashboard
                    currentOrganisation={currentOrganisation}
                    reportData={reportData}
                    mapData={mapData}
                    levelInformation={levelInformation}
                    noOfAlarms={noOfAlarms}
                    equipmentWeight={equipmentWeight}
                    unClearedAlarms={unClearedAlarms}
                    setSelectedColor={setSelectedColor}
                    selectedColor={selectedColor}
                  />
                )}
              />
              <Route
                exact
                path={`${path}/equipment`}
                component={() => (
                  <Equipment
                    currentOrganisation={currentOrganisation}
                    reportData={reportData}
                    reportDataFields={reportDataFields}
                  />
                )}
              />
              <Route
                exact
                path={`${path}/report`}
                component={() => (
                  <Report
                    page={page}
                    setTokenStillValid={setTokenStillValid}
                    currentOrganisation={currentOrganisation}
                    dataType={dataType}
                  />
                )}
              />
              <Route
                exact
                path={`${path}/alarms`}
                component={() => (
                  <Alarm
                    currentOrganisation={currentOrganisation}
                    unClearedAlarms={unClearedAlarms}
                    alarms={alarms}
                  />
                )}
              />
              <Route
                exact
                path={`${path}/admin`}
                component={() => (
                  <Admin
                    setRefreshData={setRefreshData}
                    refreshData={refreshData}
                    currentOrganisation={currentOrganisation}
                    userLists={userLists}
                  />
                )}
              />
              <Route
                exact
                path={`${path}/adminEditUser/:userid`}
                component={() => (
                  <AdminEditUser
                    orgList={orgList}
                    setRefreshData={setRefreshData}
                    setEditUserOrg={setEditUserOrg}
                  />
                )}
              />
              <Route
                exact
                path={`${path}/adminAddUser`}
                component={() => (
                  <AdminAddUser
                    userLists={userLists}
                    setRefreshData={setRefreshData}
                    currentOrganisation={currentOrganisation}
                  />
                )}
              />
            </Switch>
          </div>
        </main>
      </div>
    </ThemeProvider>
  );
};

export default DashboardPage;
